import { useNuxtApp } from '#app'
import { useAdvertisementStore } from '~/stores/advertisement'
import { useCustomerLoginStore } from '~/stores/login/customer'
//import type Swal from 'sweetalert2';
type FollowersValue = string | null | undefined

export function useAdFollowers() {
  //const { $swal } = useNuxtApp();
  
 // const swal = $swal as typeof Swal
  const adsStore = useAdvertisementStore()
  const customerStore = useCustomerLoginStore()

  const followed = ref(false)

  const isFollowedByCustomer = (followers: FollowersValue, customerId: string | number | null | undefined) => {
    if (!followers || !customerId) return false

    return String(followers)
      .split(',')
      .map(x => x.trim())
      .some(x => x === String(customerId))
  }

  const syncFollowedFromFollowers = (followers: FollowersValue) => {
    followed.value = isFollowedByCustomer(followers, customerStore.customer?.id)
  }

  const toggleFollow = async (adId: number | string) => {
    // gost: odmah na prijavu, bez poziva ka serveru i bez poruke o uspesnom pracenju
    if (!customerStore.loggedIn) {
      await navigateTo('/login')
      return null
    }

    const Swal = (await import('sweetalert2')).default
    const result = await adsStore.followerAdCache(adId)

    // sesija je istekla: server vraca 401 (poruka o prijavi se vec prikazala u store-u)
    if (result?.status === 401) {
      await navigateTo('/login')
      return null
    }

    const data = result?.data
    if (!data) return null

    Swal.fire({
      title: data.message,
      icon: !data.success ? 'warning' : 'success',
      position: 'top-end',
    })

   

    followed.value = Boolean(data.followed)
    return data
  }

  return {
    followed,
    syncFollowedFromFollowers,
    toggleFollow,
  }
}
